module.exports = __webpack_public_path__ + "static/media/telia.8bbfc303.svg";